import React from "react";

export const HEXDropDownArrowIcon = () => {
  return (
    <svg
      width="18"
      height="10"
      viewBox="0 0 18 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={"c-hex-dropdown-arrow-icon"}
    >
      <path
        d="M1.3335 1.30506L9.01891 8.99048L16.9999 1.00947"
        stroke="black"
      />
    </svg>
  );
};
